import { type BroadcastChannel } from 'broadcast-channel';

export enum Actions {
  OPEN_PROFILE = 'OPEN_PROFILE',
}

export type MessageData = {
  [key: string]: any;
};

export type Message = {
  action: Actions;
  data?: MessageData;
};

export const sendMessage = (channel: BroadcastChannel, message: Message) => {
  channel.postMessage(message);
};
